import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Window } from './components';

function App() {
  return (
    <Window />
  );
}

ReactDOM.render(<App/>, window.app);
